var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNutFreeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.243,
    height: 70.621,
    viewBox: "0 0 64.243 70.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2-nut-free{fill:none;stroke-width:3px;stroke:#e5b515;stroke-miterlimit:10}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NutFree",
    transform: "translate(-217.379 -449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_108",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeWidth: "3px",
    d: "M0 58L58 0",
    transform: "translate(221.5 459.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1454",
    transform: "translate(-1173 -823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_95",
    d: "M0 7L0 0",
    className: "cls-2-nut-free",
    transform: "translate(1422 1272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    d: "M1398 1320.353v2.824h48v-2.824s-1.412-18.353-24-18.353-24 18.353-24 18.353z",
    className: "cls-2-nut-free",
    transform: "translate(0 -22.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    d: "M1455.529 1410v11.294c0 15.529-19.765 22.588-19.765 22.588s-19.764-7.058-19.764-22.588V1410",
    className: "cls-2-nut-free",
    transform: "translate(-13.765 -105.529)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    d: "M1485.727 1516.371a24.264 24.264 0 0 0 3.358 1.8",
    className: "cls-2-nut-free",
    transform: "translate(-67.085 -186.872)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    d: "M1440 1464c1.412 4.235 5.647 8.471 7.649 9.993",
    className: "cls-2-nut-free",
    transform: "translate(-32.118 -146.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_96",
    d: "M0 7L0 0",
    className: "cls-2-nut-free",
    transform: "translate(1408 1293)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_97",
    d: "M0 11L0 0",
    className: "cls-2-nut-free",
    transform: "translate(1415 1289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_98",
    d: "M0 7L0 0",
    className: "cls-2-nut-free",
    transform: "translate(1422 1293)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_99",
    d: "M0 8L0 0",
    className: "cls-2-nut-free",
    transform: "translate(1429 1292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_100",
    d: "M0 5L0 0",
    className: "cls-2-nut-free",
    transform: "translate(1436 1295)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_107",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: "3px",
    d: "M0 58L58 0",
    transform: "translate(219.5 457.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutFreeIcon);
export default __webpack_public_path__ + "static/media/nutFree-icon.4c567ae9.svg";
export { ForwardRef as ReactComponent };